import {observable, action} from 'mobx';
import _ from 'lodash';
import shortid from 'shortid';

const spd_quizzes = [
  {
    question: '',
    correct: '',
    options: [],
    key_learnings: '',
  },
  {
    question: '',
    correct: '',
    options: [],
    key_learnings: '',
  },
  {
    question: '',
    correct: '',
    options: [],
    key_learnings: '',
  },
  {
    question: '',
    correct: '',
    options: [],
    key_learnings: '',
  },
  {
    question: '',
    correct: '',
    options: [],
    key_learnings: '',
  },
  {
    question: '',
    correct: '',
    options: [],
    key_learnings: '',
  },
  {
    question: '',
    correct: '',
    options: [],
    key_learnings: '',
  },
  {
    question: '',
    correct: '',
    options: [],
    key_learnings: '',
  },
  {
    question: '',
    correct: '',
    options: [],
    key_learnings: '',
  },
  {
    question: '',
    correct: '',
    options: [],
    key_learnings: '',
  }
];

class TopicsStore {

  @observable topics = [];
  @observable letters = [];
  @observable isSingle = false;
  @observable topic = _.assign({},
    {
      title: '',
      description: '',
      podcast_title: '',
      podcast_description: '',
      podcast_url: '',
      podcasts_attributes: [],
      tutorial_videos_attributes: [],
      is_visible_quize: false,
      // video_url: '',
      // friendly_id_url: '',
      spd_quizzes: spd_quizzes,
      cpd_status: false,
      icgp_number: '',
      cpd_points: '',
      tutorial_type: '',
      reimbursement_type: '',
    });
  @observable clearTopics = [];
  @observable errors = {};

  @action
  setTopics = topics => {
    this.clearTopics = topics;
    this.topics = this.sortTopicsAlphabetically(this.sortTopics(topics));
    this.letters = this.getLetters(this.topics);
    this.isSingle = false;
  };

  @action
  initNewTopic = () => {
   this.topic = _.assign({}, {
    title: '',
    description: '',
    podcast_title: '',
    podcast_description: '',
    podcast_url: '',
    podcasts_attributes: [],
    tutorial_videos_attributes: [],
    cpd_status: false,
    icgp_number: '',
    cpd_points: '',
    is_visible_quize: false,
    tutorial_type: '',
    reimbursement_type: '',
    spd_quizzes: spd_quizzes,
  });
  };

  @action
  setError = errors => {
    this.errors = errors;
  };

  @action
  getErrorToQuiz = i => {
    if(!this.errors)
      return {};
    const index = _.findIndex(this.errors.spd_quizzes, el => el.i === i);
    if(index === -1)
      return {};
    return this.errors.spd_quizzes[index];
  };

  @action
  clearQuizes = () => {
    this.topic.spd_quizzes = spd_quizzes;
  };

  @action
  setTopic = topic => {
    this.topic = topic;
    this.isSingle = true;
  };

  @action
  updateTopic = topic => {
    let oldTopicIndex = this.clearTopics.findIndex(e => e.id === topic.id);
    this.clearTopics[oldTopicIndex] = topic;
    this.setTopics(this.clearTopics);
  }

  @action
  saveTopic = topic => {
    this.clearTopics.push(topic);
    this.setTopics(this.clearTopics);
  }

  getTopicById = id => {
    return this.topics.find( el => el.id === id)
  };

  @action
  handleUpdateTopic = newTopic => {
    let oldTopic = this.getTopicById(newTopic.id);
    _.assign(oldTopic, newTopic);
  };

  @action
  createTopic = topic => {
    this.topics.unshift(topic);
  };

  @action
  deleteTopic = id => {
    let index = _.findIndex(this.clearTopics, el => el.id === id );
    this.clearTopics.splice(index,1);
    this.setTopic(this.clearTopics);
  };

  @action
  sortTopicsAlphabetically = topics => {
    const sorted = topics.reduce((a, c) => {
      let k = c.title.charAt(0).toUpperCase();
  
      if (a[k]) a[k].push(c)
      else a[k] = [c]
  
      return a;
    }, {});
  
    return sorted;
  };

  @action
  getLetters = sortedTopics => {
    return _.orderBy(_.keys(sortedTopics), String, ['asc']);
  }

  @action
  sortTopics = topics => {
    return topics.sort((topic_a, topic_b) => topic_a.title.localeCompare(topic_b.title));
  }

  @action
  handleChange = data => {
    _.assign(this.topic, data);
  }

  @action
  handleChangeQuiz = data => {
    this.topic.spd_quizzes = data;
  }

  @action
  addQuizOption = (data) => {
    this.topic.spd_quizzes = data;
  };
}

export default new TopicsStore();



// WEBPACK FOOTER //
// ./src/stores/TopicsStore.js